import React, { useState, useEffect } from "react";
import { Text, StyleSheet, View, FlatList, Platform } from "react-native";

import cardStyles from "./cardStyles";

import CloseIcon from "../../common/dialog/CloseIcon";
import ReportsIcon from "../../common/icons/more/ReportsIcon";
import { hasItems, navigate, pluralize } from "../../../../helpers/utils";
import CardUtils from "./CardUtils";
import {
  computeReportReceivers,
  getAllUsers,
  groupReportsByTeam,
} from "../../users/UsersHelper";
import ReportItemWrapper from "../../reports/list/ReportItemWrapper";
import appStyles from "../../../appStyles";
import ManaButton from "../../common/ManaButton";
import AppTheme from "../../AppTheme";
import appPages from "../../../../appPages";

export default function NewReportsCard({
  controller,
  data = {},
  isSnoozed = false,
  onSnooze = null,
}) {
  const [showCard, setShowCard] = useState(true);

  const cardUtils = new CardUtils(controller, data, setShowCard);

  useEffect(() => {
    cardUtils.restoreCard(data.stored_data);
  }, []);

  // ------------------------------------- METHODS -------------------------------------
  const viewReports = () => {
    controller.navigation?.jumpTo(appPages.receivedReports);
  };

  const viewReport = (report) => {
    const entity = "report:" + report.id;
    const params = { reportId: report.id };
    controller.getApiData(entity, params, (d) => {
      navigate(controller, "rn:view_report", "changepage", {
        report: {
          ...d,
          users: report.users,
        },
      });
    });
  };
  // -------------------------------------END METHODS -------------------------------------

  const dataModel = data;

  const users = getAllUsers(controller);
  let reports = groupReportsByTeam(dataModel.reports || [], controller);
  reports = computeReportReceivers(reports, "received");

  const title =
    "You’ve received " +
    (reports.length === 1 ? "a new report!" : "new reports!");

  return false && !isSnoozed && !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { minHeight: 80, height: "auto" }]}>
        <CloseIcon
          onPress={(e) => onSnooze(cardUtils, e)}
          style={cardStyles.closeButton}
        />
        <View style={[cardStyles.header, { paddingHorizontal: 0, height: 24 }]}>
          <ReportsIcon width={24} height={24} />

          <View style={[cardStyles.headerInfo, { marginLeft: 6 }]}>
            <Text style={cardStyles.title}>{title}</Text>
          </View>
        </View>

        {hasItems(reports) ? (
          <FlatList
            style={[appStyles.scrollView]}
            data={reports}
            keyExtractor={(r, index) => r.id + index}
            renderItem={({ item }) => (
              <ReportItemWrapper
                report={item}
                user={users[item.email_user]}
                editReport={viewReport}
                type="received"
                isCardReport={true}
                controller={controller}
              />
            )}
          />
        ) : (
          <View style={styles.content}>
            <Text style={styles.textArea}>
              You have {pluralize("new report", dataModel.count || 1)}!
            </Text>

            <ManaButton
              onPress={viewReports}
              style={[cardStyles.buttonSmall, { minWidth: 60, height: 30 }]}
              styleText={cardStyles.buttonSmallText}
              text="View"
            />
          </View>
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textArea: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
});
